import { ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import { Button, Input, Modal, notification, Space } from "antd";
import { useDeleteCategoriesMutation, useGetCategoriesQuery } from "api";
import { OBJ_COLOR } from "commons/constants";
import { CardComponent } from "components";
import { useDebounce } from "hooks/useDebounce";
import { ButtonExportExcel, CategoriModel, TableCategories } from "pages/categories/components";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
const { confirm } = Modal;

interface Pagination {
	current: number;
	pageSize: number;
	total: number;
	showSizeChanger: boolean;
}

const SpaceCustom = styled(Space)`
	justify-content: space-between;
	display: flex;
	margin-bottom: 20px;
	width: 100%;
	@media (max-width: 750px) {
		display: block;
		.wp-button {
			margin-top: 10px;
			width: 100%;
			display: flex;
			justify-content: space-between;
		}
	}
`;
export const MedicineList = () => {
	const [visible, setVisible] = useState(false);
	const [dataModal, setDataModal] = useState<DataCategoriesType | undefined>();
	const [titleModal, setTitleModal] = useState("");
	const [idCategories] = useState(3);
	const [param, setParam] = useState({ pageNumber: 1, pageSize: 10 });
	const [search, setSearch] = useState<string>("");
	const [pagination, setPagination] = useState<Pagination>();
	const [deleteCategories] = useDeleteCategoriesMutation();
	const debouncedValue = useDebounce(search, 500);

	const paramApi = useMemo(() => {
		const query = {
			...param,
			datatype_id: 3,
		};
		if (!debouncedValue) return query;

		return {
			...query,
			search: debouncedValue,
		};
	}, [param, debouncedValue]);

	const { data: categories, isLoading, isFetching } = useGetCategoriesQuery(paramApi);

	useEffect(() => {
		if (!categories) return;

		setPagination({
			current: param.pageNumber,
			pageSize: param.pageSize,
			total: categories.totalCount,
			showSizeChanger: true,
		});
	}, [categories, param]);

	const handleOnChangePagination = (value: any) => {
		setParam({ pageNumber: value.current, pageSize: value.pageSize });
	};

	const handleOnClickEdit = (value: DataCategoriesType) => {
		setDataModal(value);
		setVisible(true);
		setTitleModal("Edit Feed");
	};
	const handleOnClickCreate = () => {
		setVisible(true);
		setTitleModal("Create Feed");
		setDataModal(undefined);
	};
	const showDeleteConfirm = (value: DataCategoriesType) => {
		confirm({
			title: "Delete ?",
			icon: <ExclamationCircleFilled />,
			content: "Are you sure you want to delete this item?",
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			onOk() {
				const FetchApi = async () => {
					try {
						await deleteCategories(value.id).unwrap();
						notification.success({
							message: "Success",
						});
					} catch (e: any) {
						notification.error({
							message: e.data.message,
						});
					}
				};
				FetchApi();
			},
		});
	};

	const handleInputSearch = (value: string) => {
		setSearch(value);
		setParam((prev) => ({ ...prev, pageNumber: 1 }));
	};

	return (
		<>
			<CardComponent title={"Medicine Management"}>
				<SpaceCustom>
					<Input placeholder="Search..." value={search} onChange={(e) => handleInputSearch(e.target.value)} />
					<Space className="wp-button">
						<ButtonExportExcel dataTypeId={idCategories} nameFile={"categories-medicine"} />
						<Button onClick={handleOnClickCreate} style={{ background: OBJ_COLOR.SUCCESS }} type="primary" icon={<PlusOutlined />}>
							Create new
						</Button>
					</Space>
				</SpaceCustom>
				<TableCategories
					dataSource={categories?.items || []}
					handleOnClickEdit={handleOnClickEdit}
					handleOnClickDelete={showDeleteConfirm}
					loading={isLoading || isFetching}
					pagination={pagination}
					handleOnChangePagination={handleOnChangePagination}
				/>
				<CategoriModel visible={visible} setVisible={setVisible} dataModal={dataModal} title={titleModal} datatype_id={idCategories} />
			</CardComponent>
		</>
	);
};
